import { DateTime } from 'luxon';
import userState from '@/store/user';
import { FieldChildrenProp } from '@/services/hexabase/types';

// eslint-disable-next-line @typescript-eslint/no-namespace
namespace optionalForm {
  export const SAMPLE = [
    {
      'display_id': 'form_type_dslookup',
      component: 'MasterSelectControl',
      dblookup: 'm_sample',
      props: {
        leftSideInputName: 'form_type_dslookup',
        dialogTitle: 'サンプルマスタ選択',
        label: 'データベース参照型フォーム',
        columns: [],
        body: [],
        isRightSideInputReadOnly: true
      },
      // registProps: { // 登録画面特有の初期値を付与
      //   setting: {
      //     storage :'user',
      //     key: 'getUserDepartmentId'
      //   },
      //   value: { 'item_id': '' }
      // }
    }
  ];
}

// eslint-disable-next-line @typescript-eslint/no-namespace
namespace headerForm {
  export const matterInfomationRegister: Array<FieldChildrenProp> = [
    {
      //** インタフェース利用のために必要なプロパティ、画面では未使用 **//
      "search": false,
      "show_list": false,
      "as_title": false,
      "status": false,
      "fieldIndex": 1,
      "title_order": 1,
      "full_text": false,
      "unique": false,
      "min_value": "",
      "max_value": "",
      // ****** //
      "field_id": "見込顧客番号",
      "name": "見込顧客番号",
      "display_id": "見込顧客番号",
      "dataType": "text",
      "component": "InputArea",
      "props":{
        "labelName":"見込顧客番号",
        "labelText":"見込顧客番号",
        "name":"見込顧客番号",
        "isReadonly":true,
        "isDisabled":true,
        "rules":"",
        "value": ""
      },
      "sizeX":1,
      "sizeY":1,
      "col":0,
      "row":0,
      "show":true,
    },
    {
      "search": true,
      "show_list": true,
      "as_title": false,
      "status": false,
      "fieldIndex": 1,
      "title_order": 2,
      "full_text": false,
      "unique": true,
      "min_value": "",
      "max_value": "",
      "field_id": "顧客名",
      "name": "顧客名",
      "display_id": "顧客名",
      "dataType": "text",
      "component": "InputArea",
      "props":{
        "labelName":"顧客名",
        "labelText":"顧客名",
        "name":"顧客名",
        "isReadonly":true,
        "isDisabled":true,
        "rules":"",
        "value": ""
      },
      "sizeX":1,
      "sizeY":1,
      "col":1,
      "row":0,
      "show":true,
    },
    {
      "search": true,
      "show_list": true,
      "as_title": false,
      "status": false,
      "fieldIndex": 1,
      "title_order": 2,
      "full_text": false,
      "unique": true,
      "min_value": "",
      "max_value": "",
      "field_id": "顧客連絡先",
      "name": "顧客連絡先",
      "display_id": "顧客連絡先",
      "dataType": "text",
      "component": "InputArea",
      "props":{
        "labelName":"顧客連絡先",
        "labelText":"顧客連絡先",
        "name":"顧客連絡先",
        "isReadonly":true,
        "isDisabled":true,
        "rules":"",
        "value": ""
      },
      "sizeX":1,
      "sizeY":1,
      "col":3,
      "row":0,
      "show":true,
    },
    {
      "search": true,
      "show_list": true,
      "as_title": false,
      "status": false,
      "fieldIndex": 1,
      "title_order": 2,
      "full_text": false,
      "unique": true,
      "min_value": "",
      "max_value": "",
      "field_id": "案件番号",
      "name": "案件番号",
      "display_id": "案件番号",
      "dataType": "text",
      "component": "InputArea",
      "props":{
        "labelName":"案件番号",
        "labelText":"案件番号",
        "name":"案件番号",
        "isReadonly":true,
        "isDisabled":true,
        "rules":"",
        "value": ""
      },
      "sizeX":1,
      "sizeY":1,
      "col":0,
      "row":1,
      "show":true,
    },
    {
      "search": true,
      "show_list": true,
      "as_title": false,
      "status": false,
      "fieldIndex": 1,
      "title_order": 2,
      "full_text": false,
      "unique": true,
      "min_value": "",
      "max_value": "",
      "field_id": "案件名",
      "name": "案件名",
      "display_id": "案件名",
      "dataType": "text",
      "component": "InputArea",
      "props":{
        "labelName":"案件名",
        "labelText":"案件名",
        "name":"案件名",
        "isReadonly":true,
        "isDisabled":true,
        "rules":"",
        "value": ""
      },
      "sizeX":2,
      "sizeY":1,
      "col":1,
      "row":1,
      "show":true,
    },
    {
      "search": true,
      "show_list": true,
      "as_title": false,
      "status": false,
      "fieldIndex": 1,
      "title_order": 2,
      "full_text": false,
      "unique": true,
      "min_value": "",
      "max_value": "",
      "field_id": "案件ステータス",
      "name": "案件ステータス",
      "display_id": "案件ステータス",
      "dataType": "text",
      "component": "InputArea",
      "props":{
        "labelName":"案件ステータス",
        "labelText":"案件ステータス",
        "name":"案件ステータス",
        "isReadonly":true,
        "isDisabled":true,
        "rules":"",
        "value": ""
      },
      "sizeX":1,
      "sizeY":1,
      "col":3,
      "row":1,
      "show":true,
    },
  ]
}

export const matterInfomationRegisterHeader = headerForm.matterInfomationRegister;

// eslint-disable-next-line @typescript-eslint/no-namespace
namespace masterForm {
  export const MASTERCONTROLCOLUMS: { [k: string]: Array<{ [k: string]: string }> } = {
    'm_customer' : [
      { value: 'customer_id', text: '見込顧客番号', width: '30%' },
      { value: 'customer_name', text: '顧客名', width: '50%' }
    ],
    'm_customer_department' : [
      { value: 'department_id', text: '部署番号', width: '20%' },
      { value: 'department_name', text: '部署名', width: '20%' }
    ],
    'm_leasing_company' : [
      { value: 'id', text: 'ID', width: '10%' },
      { value: 'leasing_company', text: 'リース会社名', width: '40%' },
      { value: 'telephone_number', text: '電話番号', width: '50%' }
    ],
    'm_rate' : [
      { value: 'id', text: 'ID', width: '10%' },
    ],
    'm_employee' : [
      { value: 'order_manager_code', text: '担当者コード', width: '25%' },
      { value: 'name', text: '氏名', width: '30%' },
      { value: 'group_relation', text: '部・課 （所属グループ）', width: '45%' }
    ],
    'm_company' : [
      { value: 'id', text: 'ID', width: '20%' },
      { value: 'company_name', text: '所属会社名', width: '20%' }
    ],
    'm_service_type' : [
      { value: 'service_type_id', text: 'サービス種別ID', width: '20%' },
      { value: 'service_type', text: 'サービス種別', width: '50%' }
    ],
    'm_commodity' : [
      { value: 'id', text: 'ID', width: '20%' },
      { value: 'commodity', text: '商材', width: '30%' }
    ],
    'm_supplier' : [
      { value: 'id', text: 'ID', width: '20%' },
      { value: 'supplier', text: '仕入れ先', width: '30%' }
    ],
    'm_project_type' : [
      { value: 'id', text: 'ID', width: '20%' },
      { value: 'project_type', text: '案件種別', width: '50%' }
    ]
  };
}

// eslint-disable-next-line @typescript-eslint/no-namespace
namespace optionalOutPutForm {
  export const PO = [
    {
      'display_id': 'issued_date',
      component: 'DatePickerArea',
      props:{
        name: 'issued_date',
        labelText: '発行日',
        rewash: false,
        rules: 'required',
        format: 'yyyy/MM/dd',
        value: DateTime.local().toString()
      },
      col: 0,
      row: 1,
      sizeX: 3,
      sizeY: 1,
      show: true
    },
    {
      'display_id': 'output_format',
      component: 'SelectArea',
      props:{
        name: 'output_format',
        label: '出力形式',
        rules: 'selectRequired',
        selectData: {
          options:[
            {text: 'PDF', value:'pdf'},
            {text: 'Excel', value:'excel'}
          ]
        },
        value: 'pdf'
      },
      col: 0,
      row: 2,
      sizeX: 3,
      sizeY: 1,
      show: true
    },
    {
      'display_id': 'form_type',
      component: 'SelectArea',
      props:{
        name: 'form_type',
        label: '作成帳票',
        isDisabled: true,
        rules: 'selectRequired',
        noDataText: 'アイテムが存在しませんでした'
      },
      col: 0,
      row: 3,
      sizeX: 3,
      sizeY: 1,
      show: true
    },
    {
      'display_id': 'template_name',
      component: 'SelectArea',
      props:{
        name: 'template_name',
        multiple: true,
        label: '帳票テンプレート',
        isDisabled: true,
        rules: 'multiSelectRequired',
        noDataText: 'アイテムが存在しませんでした'
      },
      col: 0,
      row: 4,
      sizeX: 3,
      sizeY: 1,
      show: true
    },
    // previewは未使用とする
    // {
    //   'display_id': 'preview',
    //   component: 'PopImagePreView',
    //   props:{
    //     name: 'preview',
    //     buttonLabel: 'プレビュー',
    //     title: '帳票プレビュー',
    //     isDisabled: true,
    //   },
    //   col: 3,
    //   row: 4,
    //   sizeX: 1,
    //   sizeY: 1,
    //   show: true
    // },
  ]
}

// eslint-disable-next-line @typescript-eslint/no-namespace
namespace materialOptionalOutPutForm {
  export const PO = [
    {
      'display_id': 'issued_date',
      component: 'DatePickerArea',
      props:{
        name: 'issued_date',
        labelText: '発行日',
        rewash: false,
        rules: 'required',
        format: 'yyyy/MM/dd',
        value: DateTime.local().toString()
      },
      col: 0,
      row: 1,
      sizeX: 3,
      sizeY: 1,
      show: true
    },
    {
      'display_id': 'output_format',
      component: 'SelectArea',
      props:{
        name: 'output_format',
        label: '出力形式',
        rules: 'selectRequired',
        selectData: {
          options:[
            {text: 'Excel', value:'excel'}
          ]
        },
        value: 'excel'
      },
      col: 0,
      row: 2,
      sizeX: 3,
      sizeY: 1,
      show: true
    },
    {
      'display_id': 'form_type',
      component: 'SelectArea',
      props:{
        name: 'form_type',
        label: '作成帳票',
        isDisabled: true,
        rules: 'selectRequired',
        noDataText: 'アイテムが存在しませんでした'
      },
      col: 0,
      row: 3,
      sizeX: 3,
      sizeY: 1,
      show: true
    },
    {
      'display_id': 'template_name',
      component: 'SelectArea',
      props:{
        name: 'template_name',
        multiple: true,
        label: '帳票テンプレート',
        isDisabled: true,
        rules: 'multiSelectRequired',
        noDataText: 'アイテムが存在しませんでした'
      },
      col: 0,
      row: 4,
      sizeX: 3,
      sizeY: 1,
      show: true
    }
  ]
}

export const optionalFormSample = optionalForm.SAMPLE;
export const masterControlColums = masterForm.MASTERCONTROLCOLUMS;
export const optionalOutPutFormPO = optionalOutPutForm.PO;
export const materialOptionalOutPutFormPO = materialOptionalOutPutForm.PO;

// eslint-disable-next-line @typescript-eslint/no-namespace
namespace formDefine {
  // APIから取得したDatatypeと使用するべきモジュールコンポーネントをマッピング用
  export const MAPPING: { [k: string]: { component: string; props: string[] } } = {
    text: {
      component: 'InputArea',
      props: ['labelName', 'labelText', 'name']
    },
    number: {
      component: 'InputArea',
      props: ['labelName', 'labelText', 'name' ,'inputType']
    },
    select: {
      component: 'SelectArea',
      props: ['label', 'selectData', 'name']
    },
    textarea: {
      component: 'TextArea',
      props: ['labelName', 'labelText', 'name']
    },
    datetime: {
      component: 'DatePickerArea',
      props: ['labelName', 'labelText', 'name']
    },
    radio: {
      component: 'RadioArea',
      props: ['label', 'selectData', 'name']
    },
    dslookup: {
      component: 'MasterSelectControl',
      props: ['leftSideInputName', 'dialogTitle', 'label', 'isRightSideInputReadOnly']
    },
    status: {
      component: 'SelectArea',
      props: ['label', 'selectData', 'name']
    },
  };
  // 使用するモジュールコンポーネントの各propsにセットするAPIの返り値をマッピング
  export const settingPropsValue: { [k: string]: string } = {
    labelName: 'display_id',
    labelText: 'name',
    label: 'name',
    name: 'display_id',
    selectData: 'options',
    inputType: 'dataType'
  };
}

export const formMapDefineData = formDefine.MAPPING;
export const formMapPropsDefineData = formDefine.settingPropsValue;

// 帳票関連
export const formFormatReplaceStr = 'supports_';

// ファイル関連
export const fileActionMasterDefuneName = {
  delete: {
    success: 'FILE_DELETE_SUCCESS_MESSAGE',
    fail   : 'FILE_DELETE_FAIL_MESSAGE'
  },
  upload: {
    success: 'FILE_UPLOAD_SUCCESS_MESSAGE',
    fail   : 'FILE_UPLOAD_FAIL_MESSAGE'
  }
}
export const fileActionDefautMessage = {
  delete: {
    success: 'ファイルを削除しました。',
    fail   : 'ファイルの削除に失敗しました。'
  },
  upload: {
    success: 'ファイルを登録しました。',
    fail   : 'ファイルの登録に失敗しました。'
  }
}
export const buttonLabel: {[k: string]: string} = {
  add: '追加',
  regist: '登録',
  delete: '削除',
  download: 'ダウンロード'
}
export const tableColumn: {[k: string]: any}  = {
  columns: [
    {text: 'ファイル名',value: 'name'},
    {text: '', value: 'file_id', sortable: false, width: 70}
  ],
  buttonItems: [
    { name: 'file_id', text: '', icon: 'mdi-delete-outline', alwaysDisplayed: true, class: 'btn-icon--noframe', disabled: true }
  ]
}